import { backendRequest } from "@services/requestService";
import {
  API_BASE_URL,
  BASE_SERVICE_URL,
  CUSTOMER_SERVICES,
  DOCUMENTS_ENDPOINTS,
  STORAGE_SERVICES,
} from "@constants/services/apiRoutes";
import { DownloadDocumentResponse, DocumentResponse } from "@customTypes/responses/document";
import { FetchDocuments, FetchDownloadDocument } from "@customTypes/requests/documents";

export const fetchDocuments = async ({
  lawsuitId,
  cursor = "",
  limit = 10,
}: {
  lawsuitId: string;
  cursor?: string;
  limit?: number;
}) => {
  const url = `${API_BASE_URL}${BASE_SERVICE_URL.customer}${CUSTOMER_SERVICES.caseDocuments}`;
  let lawsuitIdNumber: number;

  try {
    lawsuitIdNumber = +lawsuitId;
  } catch (e) {
    throw new Error(
      `Was not possible to convert LawsuitId: ${lawsuitId} to Number. Error: ${e.message}`
    );
  }

  const data = await backendRequest<DocumentResponse, FetchDocuments>(url, "POST", {
    cursor,
    limit,
    query: {
      lawsuitId: lawsuitIdNumber,
    },
  });
  return data;
};

export const fetchCustomerDocuments = async () => {
  const url = `${API_BASE_URL}${BASE_SERVICE_URL.customer}${CUSTOMER_SERVICES.documents}`;

  const data = await backendRequest<DocumentResponse>(url);

  return data;
};

export const fetchDownloadUrl = async ({ fileName, gsObjectName }: FetchDownloadDocument) => {
  const url = `${API_BASE_URL}${BASE_SERVICE_URL.storage}${STORAGE_SERVICES.downloadFile}`;

  const data = await backendRequest<DownloadDocumentResponse, FetchDownloadDocument>(url, "POST", {
    fileName,
    gsObjectName,
  });

  return data;
};

export const downloadDocumentModel = async (originId: string) => {
  const url = `${API_BASE_URL}${CUSTOMER_SERVICES.documents}${DOCUMENTS_ENDPOINTS.filled}/${originId}`;
  const data = await backendRequest<{ html: string }>(url);

  return data.html;
};
